<template>
  <div class="top-wrap">
    <div class="top-left">
      <div class="location-info">
        <div class="top-city-info">
          <i class="el-icon-location"></i>
          <span>{{ cityName }}</span>
          <i class="el-icon-caret-bottom"></i>
          <!-- -->
        </div>
        <div class="top-weather-info">
          <img src="~@/assets/large/yun.png" alt="">
          <span class="weather">{{ weather }}</span>
        </div>
      </div>
      <dv-decoration-2 style="width:100%;height:7px;position: absolute;bottom: -2px;left: 0"
        :color="['#3C8F6C', '#60FCB2']" />
    </div>
    <div class="top-center">
      <img src="../../../assets/logo@2x.png" alt="">
      <div class="title">春播万象 智慧数据</div>
    </div>
    <div class="top-right">
      <div class="disease-info">
        <div>最常见疾病：<em>{{ mostFreqDisease }}</em></div>
        <span class="divider">|</span>
        <div>整体趋势：<em>{{ overallLevel }}</em></div>
      </div>
      <dv-decoration-2 style="width:100%;height:7px;position: absolute;bottom: -2px;right: 0"
        :color="['#3C8F6C', '#60FCB2']" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'TopHeader',
  data() {
    return {
      options_province: null,
      cityName: this.city,

    }
  },
  props: {
    city: { type: String, default: '北京' },
    weather: { type: String, default: '0℃' },
    mostFreqDisease: { type: String, default: '上呼吸道感染' },
    overallLevel: { type: String, default: '中等' }
  },
  created() {
    // 调用获取区划数据接口
    this.get_province()
  },
  methods: {
    // 获取区划数据
    get_province() {
      this.$http.get(process.env.VUE_APP_API_HOST + "/get_shengqu").then((res) => {
        this.options_province = res.data.data.filter(item => item.value != '')
      })
    },
    // 点击省区数据
    change_shengqu() {

    }
  }
}
</script>

<style lang="scss" scoped>
.top-wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 73px;
  // padding: 0 20px;
  color: #fff;
  box-sizing: border-box;

  //   background: rgba(116, 255, 190, 0.15);
  .top-left,
  .top-right {
    flex: 1;
    text-align: center;
    width: 30%;
    height: 100%;
    position: relative;
  }

  .top-left {

    .location-info {
      display: flex;
      align-items: center;
      gap: 20px;
      font-size: 18px;
      height: 100%;
      justify-content: center;

      i {
        color: #74ffbe;
      }

      .weather {
        color: #74ffbe;
        margin-left: 10px;
      }

      .top-city-info {
        cursor: pointer;
      }

      .top-weather-info {
        vertical-align: middle;

        img {
          display: inline-block;
          width: 24px;
          vertical-align: middle;
        }
      }
    }
  }

  .top-center {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    gap: 15px;
    margin-top: -20px;
    // background: url("~@/assets/large/top-center.png");
    // background-size: 100% 100%;

    img {
      height: 50px;
      width: auto;
      display: block;
    }

    .title {
      font-size: 28px;
      font-weight: 600;
      letter-spacing: 4px;
      background: linear-gradient(180deg, #fff 0%, #74ffbe 100%);
      -webkit-background-clip: text;
      background-clip: text;
      -webkit-text-fill-color: transparent;
      line-height: 73px;
    }
  }

  .top-right {

    .disease-info {
      display: flex;
      height: 100%;
      justify-content: center;
      align-items: center;
      font-size: 14px;

      div {
        position: relative;
      }

      // div:before {
      //   content: '';
      //   width: 9px;
      //   height: 36px;
      //   background: #FCAE60;
      //   position: absolute;
      //   top: 50%;
      //   transform: translateY(-50%);
      //   border-radius: 0px 9px 9px 0px;
      //   left: -16px;
      // }

      em {
        color: #f5a623;
        font-style: normal;
      }

      .divider {
        margin: 0 15px;
        color: #74ffbe;
      }

    }
  }
}
</style>
